export default {
    name: 'accordion-item',
    props: {
        title: {
            type: String,
            default: ''
        },
        subTitle: {
            type: String,
            default: ''
        },
        content: {
            type: String,
            default: ''
        },
        preOpened: {
            type: Boolean,
            default: false
        },
        useSlotContent: {
            type: Boolean,
            default: false
        },
        customContainer: {
            type: Boolean,
            default: false
        },
        contentClass: {
            type: String,
            default: ''
        },
        grouped: {
          type: Boolean,
          default: false
        },
        currentItem: {
          type: Number,
          default: 0
        },
        index: {
          type: Number,
          default: 0
        }
    },
    data() {
        return {
            opened: false,
        }
    },
    methods: {

    },
    mounted() {
        this.opened = this.preOpened
    },
    watch: {
        preOpened(value) {
            this.opened = value
        }
    }
}
